export class HelpSection {
  ID: number;
  SectionName: string;
  SectionLang: string;
  SortOrder: number;
}
